import { useState, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const FADE_DURATION = 350;

export function usePageTransition() {
  const navigate = useNavigate();
  const [isTransitioning, setIsTransitioning] = useState(false);
  const timeoutRef = useRef(null);

  const navigateWithTransition = useCallback((path) => {
    if (timeoutRef.current) return;
    setIsTransitioning(true);

    timeoutRef.current = setTimeout(() => {
      navigate(path);
      setTimeout(() => {
        setIsTransitioning(false);
        timeoutRef.current = null;
      }, 50);
    }, FADE_DURATION);
  }, [navigate]);

  return { isTransitioning, navigateWithTransition };
}
